export default __webpack_public_path__ + "4e713574aefdd8e4ac1f0da28bf84592.svg";